module.exports = __webpack_public_path__ + "media/assets/faria_products/AN-CPN-4ed1d869814278854f7a6b6a23f86a2f2c33bf0b194feb3cbd0f27634ad98716.png";